<template>
	<div id="hello">
		<h3 style="padding: 15px 0px;"><b style="color: #777;">{{ msg }}</b></h3>
		<div class="clearfix middle-row center">
			<div class="header middle-row around">
				<div class="headerson middle-row">
					<div class="hs-left middle-column center" style="background-color: #f1b53d;">
						<i class="fa fa-2x fa-plus-square"></i>
					</div>
					<div class="hs-right middle-column center">
						<h3 style="color: #c2c2c4">{{states.total}}</h3>
						<h4 style="color: #c2c2c4">设备总量</h4>
					</div>
				</div>
				<div class="headerson middle-row">
					<div class="hs-left middle-column center" style="background-color: #69cbcc;">
						<i class="fa fa-2x fa-gears"></i>
					</div>
					<div class="hs-right middle-column center">
						<h3 style="color: #c2c2c4">{{states.online}}</h3>
						<h4 style="color: #c2c2c4">正在运行</h4>
					</div>
				</div>
				<div class="headerson middle-row">
					<div class="hs-left middle-column center" style="background-color: darkgray;">
						<i class="fa fa-2x fa-window-close"></i>
					</div>
					<div class="hs-right middle-column center">
						<h3 style="color: #c2c2c4">{{states.total-states.online ||0}}</h3>
						<h4 style="color: #c2c2c4">设备离线</h4>
					</div>
				</div>
				<div class="headerson middle-row">
					<div class="hs-left middle-column center" style="background-color: #ff6b5c;">
						<i class="fa fa-2x fa-warning"></i>
					</div>
					<div class="hs-right middle-column center">
						<h3 style="color: #c2c2c4">{{states.warning}}</h3>
						<h4 style="color: #c2c2c4">监测报警</h4>
					</div>
				</div>
			</div>
		</div>
		<div style="margin-top: 15px; height: 8px;width: 100%;background-color: white;"></div>
		<div class="middle-row between">
			<h4 style="padding: 15px; color: #777;text-align: left;">最新数据</h4>
			<div class="time" style="padding: 15px;">
				<b style="font-size: medium;color: #777;">{{time}}</b>
			</div>
		</div>
		<div class="middle-row between newinfo">
			<div class="newleft middle-column center">
				<div class="middle-row between" style="height: 40%;width: 80%;">
					<h4><b>{{lastLampblack.merchantName}}</b></h4>
					<h4><b>餐饮油烟排放</b></h4>
				</div>
				<div class="middle-row between" style="height: 40%;width: 80%;">
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							油烟浓度
						</div>
						<div style="height: 50%;">
							{{lastLampblack.lc}} mg/m³
						</div>
					</div>
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							颗粒物浓度
						</div>
						<div style="height: 50%;">
							{{lastLampblack.pc}} mg/m³
						</div>
					</div>
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							非甲烷总烃
						</div>
						<div style="height: 50%;">
							{{lastLampblack.nmthc}} mg/m³
						</div>
					</div>
				</div>
				<div class="middle-row end" style="height: 20%;width: 80%;">
					<b>监测时间:{{lastLampblack.time}}</b>
				</div>
			</div>
			<div class="newleft middle-column center">
				<div class="middle-row between" style="height: 40%;width: 80%;">
					<h4><b>{{lastDust.merchantName}}</b></h4>
					<h4><b>工地扬尘</b></h4>
				</div>
				<div class="middle-row between" style="height: 40%;width: 80%;">
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							PM2.5
						</div>
						<div style="height: 50%;">
							{{lastDust.pm25}} μg/m³
						</div>
					</div>
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							PM10
						</div>
						<div style="height: 50%;">
							{{lastDust.pm10}} μg/m³
						</div>
					</div>
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							噪音
						</div>
						<div style="height: 50%;">
							{{lastDust.noise}} dB
						</div>
					</div>
				</div>
				<div class="middle-row end" style="height: 20%;width: 80%;">
					<b>监测时间:{{lastDust.time}}</b>
				</div>
			</div>
			<div class="newleft middle-column center">
				<div class="middle-row between" style="height: 40%;width: 80%;">
					<h4><b>{{lastCarRepair.merchantName}}</b></h4>
					<h4><b>工业企业废气</b></h4>
				</div>
				<div class="middle-row between" style="height: 40%;width: 80%;">
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							湿度
						</div>
						<div style="height: 50%;">
							{{lastCarRepair.bz}} %RH
						</div>
					</div>
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							苯系物排放
						</div>
						<div style="height: 50%;">
							{{lastCarRepair.bzs}} ppm
						</div>
					</div>
					<div class="leftmin middle-column center" style="background-color: #f5f5f5;padding: 10px;">
						<div style="height: 50%;background-color: #f5f5f5;" class="title">
							颗粒物浓度
						</div>
						<div style="height: 50%;">
							{{lastCarRepair.pc}} mg/m³
						</div>
					</div>
				</div>
				<div class="middle-row end" style="height: 20%;width: 80%;">
					<b>监测时间:{{lastCarRepair.time}}</b>
				</div>
			</div>
		</div>
		<h4 style="padding: 15px; color: #777;text-align: left;"> </h4>
		<div class="keydata middle-row around">
			<div class="kdleft middle-column around" ref="kdleft" style="padding: 15px 0px;" id="kdleft">

			</div>
			<div style="height: 100%;width: 10px;background-color: #F3F3F5;"></div>
			<div class="kdmid middle-column start" style="width: 65%;padding: 15px 0px;">
				<div id="dustavg" style="width: 100%;height: 100%;" ref="dustavg" >
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	import {
		util
	} from "../../static/util.js"
	export default {
		name: 'home',
		props: {
			msg: String
		},
		data() {
			return {
				time: '',
				charts1: '',
				lampblackAVG: '',
				dusts:'',
				charts2:'',
				dustDate:[],//扬尘时间
				pm25Data:[],//pm25
				pm10Data:[],//pm25
				noiseData:[],//pm25
				tempData:[],//pm25
				humidityData:[],//pm25
				wsData:[],//pm25
				wpData:[],//pm25
				lastLampblack:'',
				lastDust:'',
				lastOuterDoor:'',
				lastCarRepair:'',
				states:''
			}
		},
		methods: {
			//左侧油烟监控图标
			drawLine1() {
				this.charts1 = echarts.init(this.$refs.kdleft);
				this.charts1.setOption({
					color: '#69cbcc',
					title: {
						text: '辖区内24小时油烟排放平均值(mg/m³)',
						x: 'center'
					},
					grid: {
						containLabel: true,
						left:'5px',
						right:'15px',
						bottom:'15px'
					},
					xAxis: {
						name: ''
					},
					yAxis: {
						type: 'category',
						data: ['油烟浓度(标准值:2.0)', '颗粒物浓度(标准值:30.0)', '非甲烷总烃(标准值:50.0)']
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						},
						backgroundColor: 'rgba(245, 245, 245, 0.8)',
						borderWidth: 1,
						borderColor: '#ccc',
						padding: 10,
						textStyle: {
							color: 'black'
						}
					},
					series: [
					        {
					            type: 'bar',
					            data: [this.lampblackAVG.lc,this.lampblackAVG.pc,this.lampblackAVG.nmthc],
								barWidth:'30px'
					        }
					    ]
				})
			},
			drawLine2(){
				this.charts2 = echarts.init(this.$refs.dustavg);
				this.charts2.setOption({
					title: {
					        text: '辖区24小时内工地扬尘走势图',
							x: 'center'
					    },
					    tooltip: {
					        trigger: 'axis'
					    },
					    legend: {
					        data: ['PM2.5', 'PM10', '噪音', '温度', '湿度', '风速', '风力'],
							bottom:'0px',
							selected:{
								"PM2.5":true,
								'PM10':false,
								'噪音':true,
								'温度':false,
								'湿度':false,
								'风速':false,
								'风力':false
							}
					    },
					    xAxis: {
					        type: 'category',
					        boundaryGap: false,
					        data: this.dustDate
					    },
						gird:{
							containLabel: true,
							left:'5px',
							right:'5px',
							bottom:'0px'
						},
					    yAxis: {
					        type: 'value',
					    },
					    series: [
					        {
					            name: 'PM2.5',
					            type: 'line',
					            data: this.pm25Data,
					            markPoint: {
					                data: [
					                    {type: 'max', name: '最大值'},
					                    {type: 'min', name: '最小值'}
					                ]
					            },
					            markLine: {
					                data: [
					                    {type: 'average', name: '平均值'}
					                ]
					            }
					        },
					        {
					            name: 'PM10',
					            type: 'line',
					            data: this.pm10Data,
					            markPoint: {
					                data: [
					                    {type: 'max', name: '最大值'},
					                    {type: 'min', name: '最小值'}
					                ]
					            },
					            markLine: {
					                data: [
					                    {type: 'average', name: '平均值'}
					                ]
					            }
					        },
							{
							    name: '噪音',
							    type: 'line',
							    data: this.noiseData,
							    markPoint: {
							        data: [
							            {type: 'max', name: '最大值'},
							            {type: 'min', name: '最小值'}
							        ]
							    },
							    markLine: {
							        data: [
							            {type: 'average', name: '平均值'}
							        ]
							    }
							},
							{
							    name: '温度',
							    type: 'line',
							    data: this.tempData,
							    markPoint: {
							        data: [
							            {type: 'max', name: '最大值'},
							            {type: 'min', name: '最小值'}
							        ]
							    },
							    markLine: {
							        data: [
							            {type: 'average', name: '平均值'}
							        ]
							    }
							},
							{
							    name: '湿度',
							    type: 'line',
							    data: this.humidityData,
							    markPoint: {
							        data: [
							            {type: 'max', name: '最大值'},
							            {type: 'min', name: '最小值'}
							        ]
							    },
							    markLine: {
							        data: [
							            {type: 'average', name: '平均值'}
							        ]
							    }
							},
							{
							    name: '风速',
							    type: 'line',
							    data: this.wsData,
							    markPoint: {
							        data: [
							            {type: 'max', name: '最大值'},
							            {type: 'min', name: '最小值'}
							        ]
							    },
							    markLine: {
							        data: [
							            {type: 'average', name: '平均值'}
							        ]
							    }
							},
							{
							    name: '风力',
							    type: 'line',
							    data: this.wpData,
							    markPoint: {
							        data: [
							            {type: 'max', name: '最大值'},
							            {type: 'min', name: '最小值'}
							        ]
							    },
							    markLine: {
							        data: [
							            {type: 'average', name: '平均值'}
							        ]
							    }
							},
					    ]
				});
			},
			initData(){
				this.$http.get(this.GLOBAL.base+'kpi').then(function(res) {
					this.lampblackAVG = res.body.lampblacks[0];
					util.lempblackFixed(this.lampblackAVG);
					var dusts = res.body.dusts;
					var date = new Date();
					var stringtime='';
					for (let dust of dusts) {
						date.setTime(dust.time);
						stringtime = date.getDate() + '日' + date.getHours() + '时'+ date.getMinutes() + '分';
						this.dustDate.unshift(stringtime);
						this.pm25Data.unshift(dust.pm25);
						this.pm10Data.unshift(dust.pm10);
						this.noiseData.unshift(dust.noise);
						this.tempData.unshift(dust.temp);
						this.humidityData.unshift(dust.humidity);
						this.wpData.unshift(dust.wp);
						this.wsData.unshift(dust.ws);
					}
					this.drawLine1();
					this.drawLine2();
				});
				
				this.$http.get(this.GLOBAL.base+'getLastDataForIndex').then(function(msg){
					this.lastLampblack=msg.body[0];
					var date = new Date();
					date.setTime(this.lastLampblack.time);
					this.lastLampblack.time = date.getFullYear()+'年'+ (date.getMonth()+1)+'月'+date.getDate()+'日'+date.getHours()+'时'+date.getMinutes()+'分';
					
					this.lastDust=msg.body[1];
					date.setTime(this.lastDust.time);
					this.lastDust.time = date.getFullYear()+'年'+ (date.getMonth()+1)+'月'+date.getDate()+'日'+date.getHours()+'时'+date.getMinutes()+'分';
					
					this.lastOuterDoor=msg.body[2];
					date.setTime(this.lastOuterDoor.time);
					this.lastOuterDoor.time = date.getFullYear()+'年'+ (date.getMonth()+1)+'月'+date.getDate()+'日'+date.getHours()+'时'+date.getMinutes()+'分';
					
					this.lastCarRepair = msg.body[3];
					this.lastCarRepair.time = util.timeToStringWithYear(this.lastCarRepair.time);
					
					util.lempblackFixed(this.lastLampblack);
					util.dustFixed(this.lastDust);
					util.lempblackFixed(this.lastLampblack);
					util.carRepairFixed(this.lastCarRepair);
				})
				
				
				this.$http.get(this.GLOBAL.base+'getMerchantState').then(function(msg){
						this.states = msg.body;
					}
				)
			}
		},
		mounted() {
			var that = this;
			setInterval(function() {
				that.time = new Date().toLocaleString();
			}, 1000);
			
			
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.dustson {
		height: 100%;
		width: 30%;
		background-color: #F3F3F5;
	}

	.dust {
		width: 91%;
		height: 15%;
	}

	.data {
		width: 80%;
		height: 15%;
		background-color: #F3F3F5;
	}

	.data *,
	.dust * {
		width: 50%;
		font-size: medium;
	}

	.kdleft,
	.kdmid {
		height: 100%;
		width: 30%;
		border-radius: 10px;
	}

	.newleft,
	.newright {
		height: 100%;
		width: 30%;
		box-shadow: 4px 4px 6px gray;
		background-color: white;
		border-radius: 10px;
	}

	.leftmin {
		height: 95%;
		border-radius: 6px;
	}

	.newleft {
		background: -webkit-gradient(linear, 100% 100%, 0 0, from(#def3f3), to(white));
		background: -webkit-linear-gradient(to bottom right, #def3f3, white);
		background: -moz-linear-gradient(to bottom right, #def3f3, white);
		background: -o-linear-gradient(to bottom right, #def3f3, white);
		background: linear-gradient(to bottom right, #def3f3, white);
	}

	.newinfo {
		height: 170px;
		margin: 0px 15px;
	}

	.keydata {
		height: 380px;
		background-color: white;
		border-radius: 10px;
		margin: 0px 15px 10px 15px;
		box-shadow: 4px 4px 6px gray;
		position: relative;
	}

	#hello {
		background-color: #f3f3f5;
		padding-top: 10px;
		padding-bottom: 10px;
		border-radius: 10px;
	}

	* {
		font: '微软雅黑' !important;
	}

	h3 {
		margin: 40px 0 0;
	}

	b {
		color: #777;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.header {
		height: 65px;
		margin-top: 10px;
		width: 100%;
	}

	.headerson {
		width: 23%;
		height: 100%;
		background-color: white;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 2px 4px 6px grey;
	}

	.hs-left,
	.hs-right {
		width: 50%;
		height: 100%;
	}

	.fa {
		color: white;
	}
	.title{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
	}
</style>
